// icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.css';

//import bootstrap
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';

import React from 'react'
import './App.css';
import Header from './pages/global/Header/Header';
import SideBar from './pages/global/SideBar/SideBar';
import { useTheme } from './context/ThemeContext';
import DashboardTBNotif from './pages/Dashboard_TB/Dashboard_TB_Notif';
import Home from './pages/Home/Home';
import Test from './pages/Test/Test'
import { Routes, Route } from 'react-router-dom';
// aqui sao as rotas, ou seja, as paginas que vao ser acessadas

import Mapas from './pages/Mapas/Mapas';
import ComparativosInteligentes from './pages/Dashboard_TB/ComparativosInteligentes';
import RankingTabular from './pages/Dashboard_TB/RankingTabular';
import SeriesTemporais from './pages/Dashboard_TB/SeriesTemporais';


// react query (para o cache)
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { persistQueryClient } from "@tanstack/react-query-persist-client";


const queryClient = new QueryClient();

persistQueryClient({
  queryClient,
  persister: createSyncStoragePersister({ storage: window.localStorage }),
  maxAge: 1000 * 60 * 60 * 24, // fica no localstorage por  24 horas
});

function App() {
  const { theme } = useTheme();


  return (
    <QueryClientProvider client={queryClient}>
      <div className="App" id={theme}>
        <Header />
        <SideBar />
        <main id="main" className="main p-3">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/TB-notificacao" element={<DashboardTBNotif />} />
            <Route path="/TB-mapas" element={<Mapas />} />
            <Route path='/teste' element={<Test />} />
            <Route path='/TB-comparativos' element={<ComparativosInteligentes />} />
            <Route path='/TB-ranking' element={<RankingTabular />} />
            <Route path='/TB-series' element={<SeriesTemporais />} />
          </Routes>
        </main>
      </div>
    </QueryClientProvider>
  );
}

export default App;
